import {Component, HostListener} from '@angular/core';
import {CmsComponentData, ParagraphComponent} from '@spartacus/storefront';
import {CmsParagraphComponent} from '@spartacus/core';
import {Router} from '@angular/router';

/**
 * Fix for https://github.com/SAP/spartacus/issues/15780
 */
@Component({
  selector: 'dcp-dcp-paragraph',
  templateUrl: './dcp-paragraph.component.html',
})
export class DcpParagraphComponent extends ParagraphComponent {

  constructor(
    public component: CmsComponentData<CmsParagraphComponent>,
    protected router: Router
  ) {
    super(component, router);
  }

  @HostListener('click', ['$event'])
  public handleClick(event: Event): void {
    if (this.router) {
      const element = event.target as any;
      const href = element?.getAttribute('href');

      if (element.nodeName === 'UDEX-BUTTON') {
        this.router.navigateByUrl('/supportform');
      }

      // Use router for internal link navigation
      if (element.nodeName === 'UDEX-LINK') {
        this.router.navigateByUrl(href);
      }
    }
  }
}
